import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

export default function BloodPressureChart({ data }) {
  return (
    <div className="rounded-2xl bg-white p-3">
      <h3 className="mb-2 text-2xl font-bold text-navy-900">🩺 血壓記錄表</h3>
      <p className="mb-2 text-lg text-gray-500">上半是收縮壓，下半是舒張壓，每天記錄回診給醫師看更安心</p>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <XAxis dataKey="date" tick={{ fontSize: 14 }} />
          <YAxis domain={['auto', 'auto']} tick={{ fontSize: 14 }} unit=" mmHg" />
          <Tooltip labelStyle={{ fontSize: 16 }} contentStyle={{ fontSize: 18 }} />
          <Line
            type="monotone"
            dataKey="blood_pressure_sys"
            name="收縮壓"
            stroke="#dc2626"
            strokeWidth={4}
            dot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="blood_pressure_dia"
            name="舒張壓"
            stroke="#0b1f3a"
            strokeWidth={4}
            dot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}